import type { FaireProductEntity } from "../../entity_types/product";

export const p_rgt42nnem6: FaireProductEntity = {
  token: "p_rgt42nnem6",
  type: "product",
  name: "Chrome Incense Holder | The Incense Stone | Ceramic Holder",
  brandToken: "b_pn3my95u2u",
  brandName: "Oddly Specific",
  imageUrl:
    "https://cdn.faire.com/fastly/6a9716d12ae225550eccf1d612f861780da2c1f1614323caeb3bd77e9aa51b98.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/62d4c865e75b3555047193e2be8bc7105d2aa8204c88f362fb60bf83a519b11a.jpeg",
    "https://cdn.faire.com/fastly/e6b145c63f00b8a54bee249b07d5fce8048f686176e679b4cb0b13b97bd80d86.jpeg",
    "https://cdn.faire.com/fastly/cd19ab8ed6bf4f9a14e286838de0292ef2d9186d5a8c062fae885391910001a1.jpeg",
    "https://cdn.faire.com/fastly/046c337bfe788f32a1d3a9818256dc42d3013c0f68f5f6d6809d44ef0586db73.jpeg",
  ],
  priceDollars: 32,
  description:
    'Inspired by nature and crafted with intention, the Chrome Incense Stone is a harmonious blend of ceramic and metal. Compatible with a range of incense, the three-holed design works with Japanese incense, Balinese incense and Palo Santo.\n\nAltar and object — a grounded centrepiece for your sacred space.\n\n𝐃𝐞𝐭𝐚𝐢𝐥𝐬:\n• Colour: Chrome\n• Material: Ceramic base, metal holder.\n• Width: 4.5"\n• Care: To clean the Incense Stone remove the metal holder and discard of any ashes. Use water and soap to clean metal and ceramic elements. Wipe to dry.\n\nNot recommended for use with incense cones or types of incense where the flame will touch the ceramic base. When using palo santo, lean the burning end outside of the ceramic holder. Avoid letting the burning end touch the ceramic base to prevent discolouring.',
  tags: [],
  msrpDollars: 64,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:41.346Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
